await import(`@liferay/language/${Liferay.ThemeDisplay.getLanguageId()}/dynamic-data-mapping-form-web/all.js`);
/**
 * SPDX-FileCopyrightText: (c) 2000 Liferay, Inc. https://liferay.com
 * SPDX-License-Identifier: LGPL-2.1-or-later OR LicenseRef-Liferay-DXP-EULA-2.0.0-2023-06
 */

// @ts-ignore

export {default as elementSetReducer} from './elementSetReducer.es';

// @ts-ignore

export {default as formInfoReducer} from './formInfoReducer.es';

// @ts-ignore

export {default as rulesReducer} from './rulesReducer.es';

// @ts-ignore

export {default as sidebarReducer} from './sidebarReducer.es';
